/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/rules-of-hooks */
import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import Dashboardheader from "./common/Dashboardheader";
import React, { useState, useEffect } from "react";
import RangeSlider from "react-bootstrap-range-slider";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";

import { Formik } from "formik";
import * as Yup from "yup";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleSignup } from "../store/actions/authAction";
import googlePlusIcon from "/public/assets/images/flat-color-iconsgoogle.png";
import FacebookIcon from "/public/assets/images/brandicofacebook-rect.png";
import FacebookLogin from 'react-facebook-login';
import { useSession, signIn, signOut } from "next-auth/react";




function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
}
function responseFacebook(response) {
  console.log(response);
}
const componentClicked = (response) => {
  console.log(response)
}

const schema = Yup.object().shape({
  name: Yup.string().required("Nom nécéssaire"),
  email: Yup.string()
    .required("Mot de passe nécessaire")
    .email("Invalid email format"),
  password: Yup.string()
    .required("Mot de passe nécessaire")
    .min(8, "Mot de passe must be at least 8 characters"),
  confirm_password: Yup.string()
    .required("Confirmer Mot de passe nécessaire")
    .min(8, "Mot de passe must be at least 8 characters")
    .oneOf([Yup.ref("password")], "Confirmer mot de passe must match New Mot de passe"),
});

const register = (props) => {
  const dispatch = useDispatch();
  const size = useWindowSize();
  const [value, setValue] = useState(0);
  const [ownerCheckValue, setOwnerCheckValue] = useState(false);
  const { data: session } = useSession();
  // console.log("signUp data", session)

  // console.log(ownerCheckValue, 'ownerCheckValueownerCheckValueownerCheckValue');

  return (
    <div
      className="MapContent navbartopmargin bg"
      style={{ minHeight: size.height }}
    >
      <Head>
        <title>Residen | {`S'inscrire`}</title>
      </Head>
      <Dashboardheader />
      <div className="container pt-4 pb-4">

        <div className="height d-flex justify-content-center align-items-center">
        
          <div className="form-main-box">
          <div  className="socialIcons mb-4">
              <button type="button" className="btn frm-btn-google" onClick={() => signIn()} style={{ width: "30%",marginRight:"10px" }} >
                <span>
                  <Image src={googlePlusIcon} />
                </span>{" "}
                Google
              </button>
              {/* <FacebookLogin
                appId="3366727610205344"
                // autoLoad={true}
                fields="name,email,picture"
                onClick={componentClicked}
                callback={responseFacebook} /> */}
                <FacebookLogin
                appId="3123350514594094"
                // autoLoad={true}
                fields="name,email,picture"
                onClick={componentClicked}
                callback={responseFacebook}
                cssClass="btn frm-btn-facebook"
                icon={<Image src={FacebookIcon} />}
                textButton="&nbsp;&nbsp;Facebook"
              />
            </div>
            <Formik
              validationSchema={schema}
              initialValues={{
                name: "",
                email: "",
                password: "",
                confirm_password: "",
              }}
              validate={(values) => {
                const errors = {};
                return errors;
              }}
              enableReinitialize
              onSubmit={(values) => {
                const { name, email, password, confirm_password } = values;
                dispatch(
                  handleSignup({ name, email, password, confirm_password, owner_check: ownerCheckValue ? 'YES' : 'NO', age_meter: value })
                );
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <input
                      type="text"
                      name="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.name}
                      className="form-control"
                      placeholder="Nom"
                    />
                    <span className="error text-danger">
                      {errors.name && touched.name && errors.name}
                    </span>
                  </div>
                  <div className="mb-4">
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      className="form-control"
                      placeholder="Email"
                    />
                    <span className="error text-danger">
                      {errors.email && touched.email && errors.email}
                    </span>
                  </div>
                  <div className="mb-4">
                    <input
                      type="password"
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      className="form-control"
                      placeholder="Mot de passe"
                    />
                    <span className="error text-danger">
                      {errors.password && touched.password && errors.password}
                    </span>
                  </div>
                  <div className="mb-4">
                    <input
                      type="password"
                      name="confirm_password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.confirm_password}
                      className="form-control"
                      placeholder="Confirmer mot de passe"
                    />
                    <span className="error text-danger">
                      {errors.confirm_password &&
                        touched.confirm_password &&
                        errors.confirm_password}
                    </span>
                  </div>
                  <div className="input-group mb-4 form-rangeslider-bx">
                    <label>Age:</label>
                    <div className="weat-temp-rangeslider">
                      <RangeSlider
                        value={value}
                        tooltipLabel={currentValue => `${currentValue} Years`}
                        onChange={(changeEvent) =>
                          setValue(changeEvent.target.value)
                        }
                      />
                    </div>
                  </div>
                  <div className="mb-4 aoy-text">
                    <div className="">
                      {" "}
                      Déjà propriétaire ? <strong>
                        <input type="checkbox" checked={ownerCheckValue} onChange={(changeEvent) =>
                          setOwnerCheckValue(changeEvent.target.checked)
                        } />
                      </strong>
                    </div>
                  </div>
                  <div className="input-group">
                    <button
                      className="btn frm-btn-cmn"
                      type="submit"
                      disabled={isSubmitting}
                    >
                      C'est parti ! 
                    </button>
                  </div>
                </form>
              )}
            </Formik>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default register;
